module.exports = __webpack_public_path__ + "img/img_new_top2.6d63cf1c.png";